import { useState, useEffect } from "react";
import * as ReactBootStrap from "react-bootstrap";

import FormData from "form-data";

import axios from "axios";

function NudityCheck() {
    const [cardData, setCardData] = useState({
        status: "",
        remark: "",

    });
    const [img, setImg] = useState();
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        // console.log("ththth", cardData);
    }, [cardData]);

    const onChange = (e) => {
        var file = e.target.files[0];
        let base64String = "";

        var reader = new FileReader();
        // console.log("next");

        reader.onload = function () {
            base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
            // console.log("base64String", base64String);
            setImg("b " + base64String);
        };
        reader.readAsDataURL(file);
    };

    const submit = () => {
        setLoading(false);
        setCardData({
            status: "",
            remark: ""
        });
        var data = new FormData();
        data.append("ImageByte", img);
        var config = {
            method: "post",
            url: "https://z7qhk7bd2d.execute-api.ap-south-1.amazonaws.com/default/liveliness_nuditycheck_uat",

            headers: {
                "x-api-key": "Lkwecn5TjQ6Mayn7FFIlA6rvZzR34FGO1OacNSi6",
                "authorizationToken": "01kjC6cwOEB79Bza"
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                console.log(JSON.stringify(response.data));
                setCardData(response.data);
                setLoading(true)
            })
            .catch(function (error) {
                setLoading(true)
                alert("Something went wrong with server");
                // console.log(error);
            });
    };

    useEffect(() => { }, [cardData]);
    return (
        <div className="container my-4">
            <h2 className="text-center mb-4">Nudity Check</h2>

            {/* File Upload and Submit Button */}
            <div className="row justify-content-center mb-4">
                <div className="col-md-4 text-center">
                    <input type="file" className="form-control" onChange={onChange} />
                </div>
                <div className="col-md-2 text-center">
                    {loading ? (
                        <button className="btn btn-primary" onClick={submit}>
                            Submit
                        </button>
                    ) : (
                        <ReactBootStrap.Spinner animation="border" />
                    )}
                </div>
            </div>

            {/* Result Display */}
            {cardData.status !== "" && (
                <div className="d-flex justify-content-center mt-4">
                    <div
                        className={`card text-white shadow-lg ${cardData.status === 0 ? "bg-primary" : "bg-danger"
                            }`}
                        style={{ width: "24rem" }}
                    >
                        <div className="card-body text-center">
                            <h4 className="card-title">Nudity Check Result</h4>
                            <hr style={{ borderColor: "white" }} />
                            <p className="card-text">
                                <strong>Status:</strong>{" "}
                                {cardData.status}
                            </p>
                            <p className="card-text">
                                <strong>Remark:</strong>{" "}
                                {cardData.remark.replace(/_/g, " ")}
                            </p>
                        </div>
                    </div>
                </div>
            )}





        </div>
    );

}

export default NudityCheck;
